import {
  Component,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  forwardRef,
} from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SmUiComponent } from 'common/components/ui-components/sm-ui/sm-ui.component';
import { AWSService } from 'common/services/core-services/aws.service';
import { SystemService } from 'common/services/core-services/system.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sm-file',
  templateUrl: './sm-file.component.html',
  styleUrls: ['./sm-file.component.scss'],
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SmFileComponent),
      multi: true,
    },
  ],
})
export class SmFileComponent
  extends SmUiComponent
  implements OnInit, OnChanges {
  @Input() Form;
  imageSrc: any = '';
  selectedFiles?: FileList;
  previews: any[] = [];
  fileList: any = [];
  files: any = [];
  pdfSrc: any = null;
  @Input() editModel: any = null;
  @Input() isReset: boolean;
  @Output() deleteMedia = new EventEmitter<any>();
  @ViewChild('uploadFile')
  uploadFile: ElementRef;
  showError: boolean = false;
  fileName: string = '';
  pdfHeader: string = '';
  viewerType: string = '';
  modalReference: NgbModalRef;
  @Input() isNewFormAdded: boolean = false;
  @Output() documentUploaded = new EventEmitter<{
    uploadedFile: any;
    file: any;
  }>();
  @Output() fileDeleted = new EventEmitter<any>();
  override ngOnInit(): void {
    super.ngOnInit();    
    if (this.editModel.data.id !== null && this.editModel.data.id !== 0) {
      this.getPatchedFile();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {


    if (this.isReset) {
      this.previews = [];
      this.fileName = '';
      if (this.uploadFile !== undefined) {
        this.uploadFile.nativeElement.value = '';
      }
    }
  }

  selectFilesForOthers(event: any, onlyFile: string = ''): void {
    this.editModel = null;
    this.selectedFiles = event.target.files;
    this.props.isReset = false;
    const img = new Image();
    img.src = window.URL.createObjectURL(this.selectedFiles[0]);
    if (this.selectedFiles && this.selectedFiles[0]) {
      const numberOfFiles = this.selectedFiles.length;
      for (let i = 0; i < numberOfFiles; i++) {
        const reader = new FileReader();

        reader.onload = (e: any) => {
          setTimeout(() => {
            const width = img.naturalWidth;
            const height = img.naturalHeight;
            const allowedOnlyImageFileTypes = [
              'image/jpeg',
              'image/jpg',
              'image/png',
              'image/webp',
            ];
            const allowedImageFileTypes = [
              'image/jpeg',
              'image/jpg',
              'image/png',
              'image/webp',
              'image/gif',
            ];
            const allowedPDFFileTypes = ['application/pdf'];
            const allowedHTMLFileTypes = ['text/html'];
            const allowedVideoFileTypes = ['video/mp4'];
            const allowedGIFFileTypes = ['image/gif'];
            // const allowed = this.ss.contentType === 1 ? 'PDF' : this.ss.contentType === 2 :

            const allowedFileTypes = [
              'application/pdf',
              'application/vnd.ms-excel',
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              'application/msword',
              'application/xlsx',
              'application/docx',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'text/plain',
              'text/csv',
              'image/jpeg',
              'image/jpg',
              'image/png',
              'image/webp',
              'image/gif',
              'text/html',
              'video/mp4',
            ];
            this.selectedFiles[0].type.includes('image')
              ? (this.viewerType = 'IMG')
              : this.selectedFiles[0].type.includes('video')
                ? (this.viewerType = 'VID')
                : (this.viewerType = 'PDF');
            if (
              onlyFile === 'IMAGE'
                ? this.props.noGif
                  ? allowedOnlyImageFileTypes.includes(
                    this.selectedFiles[0].type
                  )
                  : allowedImageFileTypes.includes(this.selectedFiles[0].type)
                : onlyFile === 'PDF'
                  ? allowedPDFFileTypes.includes(this.selectedFiles[0].type)
                  : onlyFile === 'VIDEO'
                    ? allowedVideoFileTypes.includes(this.selectedFiles[0].type)
                    : onlyFile === 'HTML'
                      ? allowedHTMLFileTypes.includes(this.selectedFiles[0].type)
                      : onlyFile === 'GIF'
                        ? allowedGIFFileTypes.includes(this.selectedFiles[0].type)
                        : allowedFileTypes.includes(this.selectedFiles[0].type)
            ) {
              if (
                this.props.propImgHeigth !== 0 &&
                this.props.propImgWidth !== 0
              ) {
                if (
                  width !== this.props.imgWidth &&
                  height !== this.props.propImgHeigth
                ) {
                  this.showError = true;
                  this.Form.controls[this.props.field_Name].reset();
                  this.uploadFile.nativeElement.value = '';
                } else {
                  this.fileName = this.selectedFiles[0].name;
                  const file = this.ss.safePipe.transform(e.target.result);
                  this.previews.push(file);
                  this.pdfSrc = e.target.result;
                  this.showError = false;
                }
              } else {
                const file = this.ss.safePipe.transform(e.target.result);
                this.previews.push(file);
                if (this.viewerType === 'PDF') {
                  this.pdfSrc = e.target.result;
                }
                this.fileName = this.selectedFiles[0].name;
                this.showError = false;
              }
            } else {
              this.ss.showError('Invalid file format');
            }
          }, 500);
        };
        reader.readAsDataURL(this.selectedFiles[i]);
        this.files.push(this.selectedFiles[i]);
        if (this.props.type !== 'multipleimagepreview') {
          this.Form.controls[this.props.field_Name].patchValue(
            this.selectedFiles[0]
          );
        } else {
          this.Form.controls[this.props.field_Name].patchValue(this.files);
        }
      }
    }
  }

  constructor(
    private modalService: NgbModal,
    public ss: SystemService,
    protected override injector: Injector,
    public aws: AWSService
  ) {
    super(injector);
  }

  getPatchedFile() {
    if (this.props.type === 'multitypeimagepreview') {
      if (this.editModel.data.uploadedFileOriginalName) {
        if (
          typeof this.editModel.data.uploadedFileOriginalName === 'object' &&
          this.editModel.data.uploadedFileOriginalName.name
        ) {
          this.fileName = this.editModel.data.uploadedFileOriginalName.name;
        } else {
          this.fileName = this.editModel.data.uploadedFileOriginalName;
        }
      }
    } else {
      if (
        this.editModel.data[this.props.propfilePathKey] !== null &&
        this.editModel.data[this.props.propfilePathKey] !== ''
      ) {
        this.fileName = this.getFileNameFromSignedUrl(this.editModel.data[this.props.propfilePathKey]);
        const image =
          environment.fileUrl + this.editModel.data[this.props.propfilePathKey];
        this.previews.push(this.ss.safePipe.transform(image));
      }
    }
  }

  detectFileCategory(url: string): string {
    try {
      const fileName = this.getFileNameFromSignedUrl(url); // Extract file name
      const extension = fileName.split('.').pop()?.toLowerCase() || "";

      // Define file categories
      const pdfExtensions = ["pdf"];
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"];
      const videoExtensions = ["mp4", "mov", "avi", "mkv", "webm"];

      if (pdfExtensions.includes(extension)) return "PDF";
      if (imageExtensions.includes(extension)) return "IMG";
      if (videoExtensions.includes(extension)) return "VID";

      return "ANY";
    } catch (error) {
      console.error("Error detecting file type:", error);
      return "ANY";
    }
  }

  selectFiles(
    event: any,
    onlyFile: string = '',
    uploadedFile: any = null
  ): void {
    this.editModel = null;
    this.selectedFiles = event.target.files;
    this.props.isReset = false;
    const img = new Image();
    if (this.selectedFiles[0].size > 51 * 1024 * 1024) {
      this.ss.showError('File size exceeds 50 MB');
      return;
    }

    // else if (file.size > 52428800) { // 50MB = 50 * 1024 * 1024
    //   this.uploadExcelModel.assessmentExcelFileError =
    //     'Document size should be less than 50MB';
    //   this.uploadExcelModel.assessmentExcelFile = null;
    //   return;
    // }
    img.src = window.URL.createObjectURL(this.selectedFiles[0]);
    if (this.selectedFiles && this.selectedFiles[0]) {
      const numberOfFiles = this.selectedFiles.length;
      for (let i = 0; i < numberOfFiles; i++) {
        const reader = new FileReader();

        reader.onload = (e: any) => {
          setTimeout(() => {
            const width = img.naturalWidth;
            const height = img.naturalHeight;
            const allowedOnlyImageFileTypes = [
              'image/jpeg',
              'image/jpg',
              'image/png',
              'image/webp',
            ];
            const allowedImageFileTypes = [
              'image/jpeg',
              'image/jpg',
              'image/png',
              'image/webp',
              'image/gif',
            ];
            const allowedPDFFileTypes = ['application/pdf'];
            const allowedHTMLFileTypes = ['text/html'];
            const allowedVideoFileTypes = ['video/mp4'];
            const allowedGIFFileTypes = ['image/gif'];
            // const allowed = this.ss.contentType === 1 ? 'PDF' : this.ss.contentType === 2 :

            const allowedFileTypes = [
              'application/pdf',
              'application/vnd.ms-excel',
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              'application/msword',
              'application/xlsx',
              'application/docx',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'text/plain',
              'text/csv',
              'image/jpeg',
              'image/jpg',
              'image/png',
              'image/webp',
              'image/gif',
              'text/html',
              'video/mp4',
            ];
            this.selectedFiles[0].type.includes('image')
              ? (this.viewerType = 'IMG')
              : this.selectedFiles[0].type.includes('video')
                ? (this.viewerType = 'VID')
                : (this.viewerType = 'PDF');
            if (
              onlyFile === 'IMAGE'
                ? this.props.noGif
                  ? allowedOnlyImageFileTypes.includes(
                    this.selectedFiles[0].type
                  )
                  : allowedImageFileTypes.includes(this.selectedFiles[0].type)
                : onlyFile === 'PDF'
                  ? allowedPDFFileTypes.includes(this.selectedFiles[0].type)
                  : onlyFile === 'VIDEO'
                    ? allowedVideoFileTypes.includes(this.selectedFiles[0].type)
                    : onlyFile === 'HTML'
                      ? allowedHTMLFileTypes.includes(this.selectedFiles[0].type)
                      : onlyFile === 'GIF'
                        ? allowedGIFFileTypes.includes(this.selectedFiles[0].type)
                        : allowedFileTypes.includes(this.selectedFiles[0].type)
            ) {
              if (
                this.props.propImgHeigth !== 0 &&
                this.props.propImgWidth !== 0
              ) {
                this.fileName = this.selectedFiles[0].name;

                const file = this.ss.safePipe.transform(e.target.result);
                this.previews.push(file);
                this.pdfSrc = e.target.result;
                this.showError = false;
                // }
              } else {
                const file = this.ss.safePipe.transform(e.target.result);
                this.previews.push(file);
                if (this.viewerType === 'PDF') {
                  this.pdfSrc = e.target.result;
                }
                this.fileName = this.selectedFiles[0].name;
                this.showError = false;
              }
            } else {
              this.ss.showError('Invalid file format');
            }
          }, 500);
        };
        reader.readAsDataURL(this.selectedFiles[i]);
        this.files.push(this.selectedFiles[i]);
        // this.onUploadedDocument(uploadedFile,this.fileName,this.files)

        if (this.props.type !== 'multipleimagepreview') {
          this.Form.controls[this.props.field_Name].patchValue(
            this.selectedFiles[0]
          );
        } else {
          this.Form.controls[this.props.field_Name].patchValue(this.files);
        }
      }
    }
  }

  removeSelectedFile(index) {
    this.fileName = '';
    if (this.editModel !== null) {
      const params = {
        isEdit: true,
        preview: this.previews[index],
        file: this.files[index],
      };
      this.deleteMedia.emit(params);
    }
    this.previews.splice(index, 1);
    this.files.splice(index, 1);
    if (this.props.type === 'singleimagepreview') {
      this.uploadFile.nativeElement.value = '';
      this.previews = [];
      this.Form.controls[this.props.field_Name].patchValue(null);
    } else {
      this.Form.controls[this.props.field_Name].patchValue(this.files);
    }
    this.validate(this.Form.controls[this.props.field_Name]);
  }

  onFileSelected(event: any, uploadedFile: any) {
    let $img: any = document.querySelector('#file');
    this.selectedFiles = event.target.files;

    if (this.selectedFiles[0].size > 2 * 1024 * 1024) {
      this.Form.controls[this.props.field_Name].setErrors({ customError: 'File size exceeds 2 MB' });
      this.ss.showError('File size exceeds 2 MB');

      return;
    }
    const file = this.selectedFiles[0];
    const allowedTypes = this.props.propFileType;
    if (!allowedTypes.includes(file.type) && this.props.type === 'multitypeimagepreview') {
      this.Form.controls[this.props.field_Name].setErrors({ customError: 'Invalid file type' });
      this.ss.showError('Only img and PDF  files are allowed');
      return;
    }

    if (typeof FileReader !== 'undefined') {
      let reader = new FileReader();

      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result;
      };
      if (this.viewerType === 'PDF') {
        reader.readAsArrayBuffer(this.selectedFiles[0]);
      }
      this.fileName = this.selectedFiles[0].name;
      this.pdfHeader = this.selectedFiles[0].name;
      this.Form.controls[this.props.field_Name].patchValue(
        this.selectedFiles[0]
      );
    }
    this.onUploadedDocument(uploadedFile, this.selectedFiles);
  }

  onUploadedDocument(uploadedFile: any, file: any) {
    this.documentUploaded.emit({ uploadedFile, file });
  }

  open(pdfviewer): void {
    if (this.editModel !== null && this.pdfSrc === null) {
      const url = environment.fileUrl + this.editModel.data.filePath;
      this.pdfSrc = url;
      this.fileName = this.getFileNameFromSignedUrl(this.editModel.data[this.props.field_Name]);
      this.pdfHeader = this.getFileNameFromSignedUrl(this.editModel.data[this.props.field_Name]);
      this.viewerType = this.detectFileCategory(this.editModel.data[this.props.field_Name]);
    }
    this.modalService.open(pdfviewer, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'lg',
    });
  }

  getFileNameFromSignedUrl(url: string): string {
    try {
      const urlObj = new URL(url);
      const pathname = urlObj.pathname; // Extract path (without query params)
      return decodeURIComponent(pathname.substring(pathname.lastIndexOf("/") + 1));
    } catch (error) {
      console.error("Invalid URL:", error);
      return "";
    }
  }

  deleteUploadDocument(event) {
    // this.fileName=''
    this.fileDeleted.emit(event);
  }

  downloadDocument(event, docName: string) {   
    console.log(event);
    
    if (event.filePath) {
      window.open(event.filePath);
    }
  }

  downloadAchievement(event, docName: string) {
    console.log('event',event);
    if (event.fileOriginalName) {

      window.open(event.fileOriginalName);
    }

  }

  truncateFileName(fileName: string, maxLength: number): string {
    return fileName && fileName.length > maxLength ? fileName.slice(0, maxLength) + '...' : fileName;
  }

}
